// filepath: apps/web/src/features/admin/userRoles/SyncRetryButton.tsx
//
// FR-UI-ADM-5 AC-6 — sticky retry button.
//
// Renders at the bottom of the page when syncStatus !== "ok".
// Calls useSyncRefresh on click; 2-second cooldown after failure
// to prevent tight retry loops.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface SyncRetryButtonProps {
  visible: boolean;
  refreshing: boolean;
  onRefresh: () => void;
}

export function SyncRetryButton({
  visible,
  refreshing,
  onRefresh,
}: SyncRetryButtonProps): React.ReactElement | null {
  const { t } = useTranslation();
  const [cooldownUntil, setCooldownUntil] = useState(0);

  if (!visible) return null;

  const cooldownActive = Date.now() < cooldownUntil;

  return (
    <button
      type="button"
      onClick={async () => {
        try {
          await onRefresh();
          setCooldownUntil(Date.now() + 2000);
        } catch {
          setCooldownUntil(Date.now() + 2000);
        }
      }}
      disabled={refreshing || cooldownActive}
      data-testid="sync-retry-button"
    >
      {cooldownActive
        ? t("admin.users.action.sync_refresh_cooldown")
        : t("admin.users.action.sync_refresh")}
    </button>
  );
}
